/**
 * Crown — page header band.
 *
 * Owns the paper bg + bottom hairline + symmetric vertical breathing room
 * (`pt-[22px] pb-4`). Internal layout is intentionally passthrough — compose
 * `<Breadcrumb>`, `<DisplayHeading>`, `<CrownMeta>`, `<Subtabs>` directly
 * inside. Subtabs (and `<Stepper>` when placed inside Crown) cancel the bottom
 * padding via `-mb-4` so they sit flush against the bottom hairline.
 *
 * Source: .agents/design/project/artboard-radical.jsx:71-138
 */

import type { ReactNode } from 'react';

interface CrownProps {
  children: ReactNode;
  className?: string;
}

export function Crown({ children, className = '' }: CrownProps) {
  return (
    <header
      className={
        // Phone (14.5): px-4 gutter — Subtabs' negative margins mirror this.
        'border-b border-line bg-paper px-8 pt-[22px] pb-4 max-sm:px-4 max-sm:pt-4 ' + className
      }
    >
      {children}
    </header>
  );
}

interface CrownRowProps {
  children: ReactNode;
  className?: string;
}

/** Heading + meta on a single row, end-aligned. */
function CrownRow({ children, className = '' }: CrownRowProps) {
  return (
    // Phone (14.5): heading and meta stack — side-by-side squeezes both.
    <div
      className={
        'flex items-end justify-between gap-8 max-sm:flex-col max-sm:items-stretch max-sm:gap-4 ' +
        className
      }
    >
      {children}
    </div>
  );
}

Crown.Row = CrownRow;
